import {Component, HostListener, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {DatePipe} from '@angular/common';
import {ApiClientService} from '../../../services/api-client.service';
import {UrlService} from '../../../services/url.service';
import {ConstantsService} from '../../../services/constants.service';
import {ResidentForSelect, ParkingPass} from '../../../types/data.types';
import {AuthenticationService} from '../../../services/authentication.service';
import {ParkingPassService} from '../../../services/parking-pass.service';
import { ResidentService } from '../../../services/resident.service';
import { Router } from '../../../../../node_modules/@angular/router';

declare const toastr: any;
declare const $: any;
declare const swal: any;
declare const moment: any;

@Component({
    selector: 'parking-pass-modal',
    templateUrl: './parking-pass-modal.component.html',
    styleUrls: ['./parking-pass-modal.component.scss']
})
export class ParkingPassModalComponent implements OnInit {
    @ViewChild('form') form;
    showModal = false;
    lots: Array<any> = [];
    rules: Array<any> = [];
    suites: Array<any> = [];
    residents: Array<ResidentForSelect> = [];
    data: ParkingPass = new ParkingPass();
    disabledSubmit = false;
    date: string = (new Date).toISOString();
    maxDateTo: string = '';
    hours = ParkingPassModalComponent.parseTime((new Date()).toISOString());
    buildingSelectIsDisabled = false;
    isEditModeNoSpinner = false;
    fullResidentsObjectArray: Array<any> = [];
    step = 'create-pass';
    monthsArray: Array<string> = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    cardMonthArray:  Array<string> = ['01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12'];
    arrayOfMonthsLastDays:  Array<number> = [
        31,
        new Date().getFullYear() % 4 == 0 ? 29 : 28,
        31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    cardYearsArray:  Array<number> = [];
    payment = {
        cardHolderName: '',
        postalCode: '',
        creditCardNumber: '',
        cardMonth: '',
        cardYear: '',
        cvv: '',
        reservationFee: '',
        securityDeposit: ''
    };
    termsAndConditions = '';
    confirmationMessage = '';
    isEditMode = false;
    bookingMaxHour = null;
    bookingMinHour = null;
    availablePaymentMethods = [];
    gettingAmenityForEditing = false;
    disclaimerText = '';
    dateTo = null;
    dateFrom = new Date();
    timeTo = '';
    timeFrom = ParkingPassModalComponent.parseTime((new Date()).toISOString());
    rule = null;
    today = new Date();
    requiredPasses: Array<any> = [];
    passesForHint: Array<any> = [];
    recentVisitorsList: Array<any> = [];
    showRequiredPassTypesSpinner = false;
    bookingPassTypes: Array<any> = [];
    disablePassRefresh = false;
    limitGroupsForHint: Array<any> = [];
    selectedBuilding: any;
    showNoPassesRequiredNotification = false;
    usedPasses: Array<any> = [];
    currentMonth = '';
    months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    gotUsedPasses = false;
    lotsAreLoading = false;

    static parseTime(dateString: string): string {
        return (new DatePipe('en-US')).transform(dateString, 'hh:mm a');
    }

    constructor(
        public api: ApiClientService,
        public parkingPassService: ParkingPassService,
        public authService: AuthenticationService,
        public urlService: UrlService,
        private residentService: ResidentService,
        private router: Router
    ) {}

    ngOnInit() {
        this.selectedBuilding = JSON.parse(localStorage.getItem('residentselectedBuilding'));
        this.initData();
        if(this.selectedBuilding) {
            if(this.parkingPassService.residentParkinglots.length == 0)
            this.residentService.getResidentLots(this.selectedBuilding.buildingId);
            this.getRegularVisitors();
        }
        const currentYear = new Date().getFullYear();
        for(let i = currentYear - 10; i < currentYear + 11; i++)
            this.cardYearsArray.push(i);
        setTimeout( () => this.showModal = true, 300);
        setTimeout(() => this.initTimePicker(), 500);
        this.urlService.modalOpened.emit();
    }

    initTimePicker() {
        let noTimeFromToIsSet = false;
        if(!this.timeTo)
            noTimeFromToIsSet = true;
        $('#timepickerfrom').timepicker().on('changeTime.timepicker', e => {
            this.timeFrom = e.time.value;
            this.onDateTimeChange('timeFrom');
        });
        $('#timepickerto').timepicker().on('changeTime.timepicker', e => {
            const dateFrom = new Date(new Date(new Date(new Date(this.dateFrom).setHours(0)).setMinutes(0)).setSeconds(0)).setMilliseconds(0);
            const dateTo = new Date(new Date(new Date(new Date(this.dateTo).setHours(0)).setMinutes(0)).setSeconds(0)).setMilliseconds(0);
            if(!(dateFrom == dateTo && new Date(`01/01/1970 ${e.time.value}`) <= new Date(`01/01/1970 ${this.timeFrom}`)))
                this.timeTo = e.time.value;
            else {
                this.timeTo = moment(`01/01/1970 ${this.timeFrom}`).format('h:mm A');
                $('#timepickerto')[0].value = moment(`01/01/1970 ${this.timeFrom}`).format('h:mm A');
            }
            this.onDateTimeChange('timeTo');
        });
        $('#timepickerto').timepicker().on('show.timepicker', e => {
            if(!this.timeTo) {
                const dateFrom = new Date(new Date(new Date(new Date(this.dateFrom).setHours(0)).setMinutes(0)).setSeconds(0)).setMilliseconds(0);
                const dateTo = new Date(new Date(new Date(new Date(this.dateTo).setHours(0)).setMinutes(0)).setSeconds(0)).setMilliseconds(0);
                if(!(dateFrom == dateTo && new Date(`01/01/1970 ${e.time.value}`) <= new Date(`01/01/1970 ${this.timeFrom}`)))
                    this.timeTo = e.time.value;
            }
        });
        if(noTimeFromToIsSet) {
            this.timeTo = '';
            $('#timepickerto')[0].value = '';
        }
    }

    openTimepicker(id): void {
        $(`#${id}`).timepicker('showWidget');
    }

    initData() {
        this.isEditModeNoSpinner = false;
        if (this.parkingPassService.parkingPassInParkingPassModal && !this.parkingPassService.isPrefilledFromDirectory) {
            this.data = JSON.parse(JSON.stringify(this.parkingPassService.parkingPassInParkingPassModal));
            if(typeof this.data.suiteId == 'string') {
                if((<any>this.data.suiteId).indexOf('-') != -1) {
                    this.data.suiteId = 0;
                    this.data.residentId = 0;
                }
            } else {
                if(this.data.suiteId.toString().indexOf('-') != -1) {
                    this.data.suiteId = 0;
                    this.data.residentId = 0;
                }
            }
            this.rule = this.data.parkingRule;
            this.data.parkingRule = this.data.parkingRule.id;
            if(this.rule.acceptCash)
                this.availablePaymentMethods.push({value: 'cash', displayName: 'Cash'});
            if(this.rule.acceptCheques)
                this.availablePaymentMethods.push({value: 'cheque', displayName: 'Cheque'});
            if(this.rule.acceptCreditCards)
                this.availablePaymentMethods.push({value: 'credit_card', displayName: 'Credit Card'});
            if(this.rule.defaultPaymentMethod)
                this.data.paymentMethod = this.rule.defaultPaymentMethod;
            if(this.rule.disclaimerStatus && (!this.rule.disclaimerHideFromStaffInterface || this.authService.userIsResident))
                this.disclaimerText = this.rule.disclaimer;
            if(this.rule.legalAgreementStatus && (!this.rule.legalAgreementHideFromStaffInterface || this.authService.userIsResident)) {
                this.termsAndConditions = this.rule.legalAgreement;
                this.confirmationMessage = this.rule.confirmationMessage;
            }
            if(this.rule.limitGroups)
                this.limitGroupsForHint = this.rule.limitGroups;
            this.dateFrom = this.getDateObjectInZeroTimeZone(this.data.dateFrom);
            this.dateTo = this.getDateObjectInZeroTimeZone(this.data.dateTo);
            this.timeFrom = ParkingPassModalComponent.parseTime(this.dateFrom.toISOString());
            this.timeTo = ParkingPassModalComponent.parseTime(this.dateTo.toISOString());
            this.data.parkingLot = (<any>this.data.parkingLot).id;
            this.step = 'create-pass';
            this.isEditMode = true;
            this.gettingAmenityForEditing = true;
            this.getLots(this.data.buildingId);
            this.isEditModeNoSpinner = true;
            if (this.data.suiteId)
                this.suites = [{id: this.data.suiteId, name: this.data.suiteNumber}];
            else
                this.suites = [{id: 0, name: 'Other'}];
            this.getSuites(this.data.buildingId, this.data.suiteId);
            if (this.data.residentId)
                this.residents = [new ResidentForSelect(this.data.residentId, this.data.residentFullName)];
            else
                this.residents = [new ResidentForSelect(0, 'Other')];
            this.data.bookingPassTypes.filter(type => {
                const matchingPasses = this.passesForHint.filter( pass => pass.name == type.passType.name);
                if(matchingPasses.length === 0)
                    this.passesForHint.push(type.passType);
                this.requiredPasses.push({
                    passTypeName: type.passType.name,
                    startTime: type.dateFrom,
                    endTime: type.dateTo,
                    repeatable: type.passType.passTypeSchedule ? type.passType.passTypeSchedule.repeatable : false,
                    allowOverlimitBooking: type.passType.allowOverlimitBooking,
                    fee: type.passType.fee,
                    selected: true,
                    available: true,
                    passTypeId: type.passType.id
                });
            });
        } else if (this.parkingPassService.parkingPassInParkingPassModal && this.parkingPassService.isPrefilledFromDirectory) {
            this.data = JSON.parse(JSON.stringify(this.parkingPassService.parkingPassInParkingPassModal));
            this.getSuites(this.data.buildingId, this.data.suiteId);
            this.getLots(this.data.buildingId);
            this.data = JSON.parse(JSON.stringify(this.parkingPassService.parkingPassInParkingPassModal));
            this.getRecentVisitors();
        } else {
            const b = this.urlService.queryParams['building'];
            if (b) {
                this.data.buildingId = b;
                this.parkingPassService.buildingsForUpdate.filter((building) => {if (building.id == b) this.data.buildingName = building.name; });
                this.getSuites(this.data.buildingId);
                this.getLots(this.data.buildingId);
            }

            if (this.parkingPassService.buildings.length === 1) {
                this.data.buildingId = this.parkingPassService.buildings[0].id;
                this.parkingPassService.buildingsForUpdate.filter((building) => {if (building.id == this.parkingPassService.buildings[0].id) this.data.buildingName = building.name; });
                this.getSuites(this.data.buildingId);
                this.getLots(this.data.buildingId);
            }
        }
        if(this.selectedBuilding) {
            this.getLots();
        }
    }

    hideModal() {
        if ((this.form.dirty && this.form.touched) ||
            (!this.isEditMode && (this.data.passTypeId || this.data.suiteId ||
             this.data.residentId || this.data.day))) {
            swal(ConstantsService.getSwalConfig('Exit without saving?', 'If you close the dialog, the data you have entered will be lost'),
                () => {
                    this.parkingPassService.isParkingPassModalShow = false;
                    this.parkingPassService.parkingPassInParkingPassModal = null;
                    this.parkingPassService.isPrefilledFromDirectory = false;
                    this.urlService.modalClosed.emit();
                }
            );
        } else {
            this.parkingPassService.isParkingPassModalShow = false;
            this.parkingPassService.parkingPassInParkingPassModal = null;
            this.parkingPassService.isPrefilledFromDirectory = false;
            this.urlService.modalClosed.emit();
        }
    }

    confirmBooking() {
        this.disabledSubmit = true;
        const data = {
            building: {
                buildingId: (Number(this.residentService.selectedBuilding.buildingId)) ||
                (this.data.buildingId ? this.data.buildingId : 0),
                buildingName: this.residentService.selectedBuilding.buildingName ||
                (this.data.buildingId ? this.data.buildingName : null),
                timezone: this.residentService.selectedBuilding.buildingTimezone ||
                (this.data.buildingTimezone ? this.data.buildingTimezone : undefined)
            },
            suite: {
                bdId: (Number(this.residentService.selectedBuilding.suite_id)) ||
                (this.data.suiteId ? this.data.suiteId :
                    (this.data.buildingId + '-' + this.data.suiteNumber).toLowerCase()),
                suiteNumber: (this.residentService.selectedBuilding.suiteNumber) || (this.data.suiteNumber)
            },
            resident: {
                bdId:     (Number(this.residentService.selectedBuilding.residentBdId)) ||
                (this.data.residentId ? this.data.residentId : 0),
                fullName: (this.residentService.selectedBuilding.userName) || (this.data.residentFullName),
                email: (this.residentService.selectedBuilding.userEmail) || (this.data.residentEmail ? this.data.residentEmail : 'notice@maxcondoclub.ca'),
            },
            // payment: this.getPaymentsFormatted(),
            visitor: {
                bdId: (Number(this.residentService.selectedBuilding.residentBdId)) || this.data.buildingId ? this.data.buildingId : 0,
                fullName: this.data.visitorFullName,
                licensePlate: this.data.visitorLicensePlate,
                vehicle: this.data.visitorVehicle
            },
            dateFrom: this.getDateTimeForSubmit(this.dateFrom, this.timeFrom),
            dateTo: this.getDateTimeForSubmit(this.dateTo, this.timeTo),
            parkingLot: this.data.parkingLot,
            parkingRule: this.data.parkingRule,
            bookingPassTypes: this.getBookingPassTypesForSending()
        };

        this.disabledSubmit = true;

        if (this.data.id) {
            this.api.patch('domainParkingPass', `/v1/booking/${this.data.id}.json`, data).subscribe(
                () => {
                    this.form.reset();
                    this.updateView('Parking Pass Booking successfully updated');
                },
                error => {
                    if(JSON.parse(error._body).errors && JSON.parse(error._body).errors.length > 0)
                        JSON.parse(error._body).errors.forEach(err => this.api.errorHandler(error, err.description));
                    else
                        this.api.errorHandler(error, 'Parking Pass update failed!');
                    this.disabledSubmit = false;
                }
            );
        } else {
            this.api.post('domainParkingPass', '/v1/booking.json', data).subscribe(
                () => {
                    this.form.reset();
                    this.updateView('Parking Pass Booking successfully created');
                },
                error => {
                    if(JSON.parse(error._body).errors && JSON.parse(error._body).errors.length > 0)
                        JSON.parse(error._body).errors.forEach(err => this.api.errorHandler(error, err.description));
                    else
                        this.api.errorHandler(error, 'Parking Pass creation failed!');
                    this.disabledSubmit = false;
                }
            );
        }
    }

    updateView(msg: string): void {
        toastr.success(msg);
        if(this.router.url !== '/home' && !this.parkingPassService.isPrefilledFromDirectory) {
            this.parkingPassService.getData();
        }
        this.form.reset();
        this.parkingPassService.isParkingPassModalShow = false;
        this.parkingPassService.parkingPassInParkingPassModal = null;
    }

    changeBuilding(buildingId: string) {
        this.isEditModeNoSpinner = false;
        this.parkingPassService.buildingsForUpdate.forEach((building) => {
            if (building.id == buildingId) {
                this.data.buildingName = building.name;
                this.data.buildingTimezone = building.timezone;
            }
        });
        this.data.residentId = null;
        this.data.residentFullName = '';
        this.data.suiteId = null;
        this.data.suiteNumber = '';
        this.getLots(+buildingId);
        this.getSuites(+buildingId);
        this.recentVisitorsList = [];
        this.requiredPasses = [];
        this.data.payment = null;
        this.passesForHint = [];
        this.limitGroupsForHint = [];
        this.bookingPassTypes = [];
        this.rules = [];
        this.disclaimerText = '';
        this.termsAndConditions = '';
        this.confirmationMessage = '';
        this.availablePaymentMethods = [];
        this.showNoPassesRequiredNotification = false;
        this.usedPasses = [];
        this.gotUsedPasses = false;
    }

    changeLot(lotId: string) {
        this.rule = null;
        this.disclaimerText = '';
        this.termsAndConditions = '';
        this.confirmationMessage = '';
        this.availablePaymentMethods = [];
        this.requiredPasses = [];
        this.data.payment = null;
        this.passesForHint = [];
        this.limitGroupsForHint = [];
        this.bookingPassTypes = [];
        this.isEditModeNoSpinner = false;
        this.data.paymentMethod = '';
        this.maxDateTo = '';
        this.data.parkingRule = null;
        this.showNoPassesRequiredNotification = false;
        this.lots.forEach( (lot) => {
            if(lot.id == parseInt(lotId)) {
                this.rules = lot.lotRule ? lot.lotRule.map(rule => (rule.parkingRule)) : [];
                this.rules = this.rules.filter(rule => rule.enableStatus);
                if (lot.lotRule.length === 1) {
                    this.rule = lot.lotRule[0].parkingRule;
                    this.data.parkingRule = this.rule.id;
                    if(lot.lotRule[0].parkingRule.acceptCash)
                        this.availablePaymentMethods.push({value: 'cash', displayName: 'Cash'});
                    if(lot.lotRule[0].parkingRule.acceptCheques)
                        this.availablePaymentMethods.push({value: 'cheque', displayName: 'Cheque'});
                    if(lot.lotRule[0].parkingRule.acceptCreditCards)
                        this.availablePaymentMethods.push({value: 'credit_card', displayName: 'Credit Card'});
                    if(lot.lotRule[0].parkingRule.defaultPaymentMethod)
                        this.data.paymentMethod = lot.lotRule[0].parkingRule.defaultPaymentMethod;
                    if(lot.lotRule[0].parkingRule.disclaimerStatus && (!lot.lotRule[0].parkingRule.disclaimerHideFromStaffInterface || this.authService.userIsResident))
                        this.disclaimerText = lot.lotRule[0].parkingRule.disclaimer;
                    if(lot.lotRule[0].parkingRule.legalAgreementStatus && (!lot.lotRule[0].parkingRule.legalAgreementHideFromStaffInterface || this.authService.userIsResident)) {
                        this.termsAndConditions = lot.lotRule[0].parkingRule.legalAgreement;
                        this.confirmationMessage = lot.lotRule[0].parkingRule.confirmationMessage;
                    }
                    if(this.rule.type == 'sliding') {
                        const offset = this.rule.passTypes[0].passTypeScheduleSliding;
                        const endTime = moment(this.dateFrom).add(offset.slidingPeriodCount, offset.slidingSequenceType + 's');
                        this.dateTo = endTime._d;
                        this.timeTo = endTime.format('h:mm A');
                        if(this.rule.maxPassCountPerBooking)
                            this.maxDateTo = moment(this.dateFrom).add(this.rule.maxPassCountPerBooking * parseInt(offset.slidingPeriodCount), offset.slidingSequenceType + 's').format();
                    }
                }
            }
        });
        this.usedPasses = [];
        if(this.data.buildingId && this.data.suiteId && this.data.parkingLot)
            this.getNumberOfUsedPasses();
    }

    changeRule(ruleId: string) {
        this.rule = null;
        this.disclaimerText = '';
        this.termsAndConditions = '';
        this.confirmationMessage = '';
        this.availablePaymentMethods = [];
        this.requiredPasses = [];
        this.data.payment = null;
        this.passesForHint = [];
        this.limitGroupsForHint = [];
        this.bookingPassTypes = [];
        this.isEditModeNoSpinner = false;
        this.data.paymentMethod = '';
        this.maxDateTo = '';
        this.showNoPassesRequiredNotification = false;
        this.rules.forEach( (rule) => {
            if(rule.id == parseInt(ruleId)) {
                this.rule = rule;
                if(rule.acceptCash)
                    this.availablePaymentMethods.push({value: 'cash', displayName: 'Cash'});
                if(rule.acceptCheques)
                    this.availablePaymentMethods.push({value: 'cheque', displayName: 'Cheque'});
                if(rule.acceptCreditCards)
                    this.availablePaymentMethods.push({value: 'credit_card', displayName: 'Credit Card'});
                if(rule.defaultPaymentMethod)
                    this.data.paymentMethod = rule.defaultPaymentMethod;
                if(rule.disclaimerStatus && (!rule.disclaimerHideFromStaffInterface || this.authService.userIsResident))
                    this.disclaimerText = rule.disclaimer;
                if(rule.legalAgreementStatus && (!rule.legalAgreementHideFromStaffInterface || this.authService.userIsResident)) {
                    this.termsAndConditions = rule.legalAgreement;
                    this.confirmationMessage = rule.confirmationMessage;
                }
                if(rule.type == 'sliding' && rule.passTypes.length) {
                    const offset = rule.passTypes[0].passTypeScheduleSliding;
                    const endTime = moment(this.dateFrom).add(offset.slidingPeriodCount, offset.slidingSequenceType + 's');
                    this.dateTo = endTime._d;
                    this.timeTo = endTime.format('h:mm A');
                    if(rule.maxPassCountPerBooking)
                        this.maxDateTo = moment(this.dateFrom).add(rule.maxPassCountPerBooking * parseInt(offset.slidingPeriodCount), offset.slidingSequenceType + 's').format();
                }
            }
        });
        this.usedPasses = [];
        if(this.data.buildingId && this.data.suiteId && this.data.parkingLot)
            this.getNumberOfUsedPasses();
    }

    changeUnit(suiteId: string) {
        if (+suiteId != this.data.suiteId) {
            this.data.suiteId = +suiteId;
            this.suites.forEach((suite) => {if (suite.id == suiteId) this.data.suiteNumber = suite.name; });
            this.isEditModeNoSpinner = false;
            this.form.controls['residentId'].reset();
            this.getResidents(+suiteId);
            this.recentVisitorsList = [];
            this.requiredPasses = [];
            this.data.payment = null;
            this.passesForHint = [];
            this.limitGroupsForHint = [];
            this.bookingPassTypes = [];
            this.showNoPassesRequiredNotification = false;
            this.gotUsedPasses = false;
            if (suiteId + '' === '0') {
                this.form.controls['residentId'].setValue(0);
                this.data.residentId = 0;
                this.data.suiteNumber = '';
                this.data.residentFullName = '';
                this.residents.push(new ResidentForSelect(0, 'Other'));
            }
            this.usedPasses = [];
            if(this.data.buildingId && this.data.suiteId && this.data.parkingLot)
                this.getNumberOfUsedPasses();
        }
    }
    getRegularVisitors() {
        if(this.residentService.selectedBuilding) {
            const suiteVisitors = this.residentService.selectedBuilding.suite_id;
            const residentId = this.residentService.selectedBuilding.residentBdId;
            const url = `/v1/parking_pass_visitors.json?suite_bd_id=${suiteVisitors}&resident_bd_id=${residentId}&is-group=1`;
            this.api.get('domainParkingPass', url).subscribe(
                res => this.recentVisitorsList = JSON.parse(res._body).entities
            );
        }
    }

    changeResident(residentId: string) {
        this.data.residentId = +residentId;
        this.recentVisitorsList = [];
        this.residents.forEach((resident) => {
            if (resident.id == +residentId) {
                this.data.residentFullName = resident.fullName;
                this.data.residentEmail = resident.email;
            }
        });
        this.isEditModeNoSpinner = false;
        if (residentId === '0')
            this.data.residentFullName = '';
        else
            this.getRecentVisitors();
    }

    getRecentVisitors() {
        const url = `/v1/parking_pass_visitors.json?suite_bd_id=${this.data.suiteId}&resident_bd_id=${this.data.residentId}&is-group=1`;
        this.api.get('domainParkingPass', url).subscribe(res => {
            if(this.data.suiteId !== 0)
                this.recentVisitorsList = JSON.parse(res._body).entities;
            else
                this.recentVisitorsList = [];
        });
    }

    getLots(buildingId?: number): void {
        if (!buildingId && !this.selectedBuilding) return;
        this.lots = [];
        if(!this.selectedBuilding) {
            this.lotsAreLoading = true;
            this.parkingPassService.getLots(buildingId).subscribe((res) => {
                    this.lotsAreLoading = false;
                    this.lots = JSON.parse(res['_body']).entities || [];
                    if(this.lots.length === 1)
                        this.setLotAndRule();
                    else if(this.lots.length > 1 && this.data.parkingRule) {
                        const ruleId = this.data.parkingRule;
                        this.changeLot(this.data.parkingLot);
                        this.changeRule(ruleId);
                        this.data.parkingRule = ruleId;
                    }
                },
                err => {
                    this.lotsAreLoading = false;
                    this.api.errorHandler(err, 'Failed to get Parking Lots')
                }
            );
        } else {
            this.lots = this.parkingPassService.residentParkinglots;
            if(this.lots.length === 1)
                this.setLotAndRule();
            else if(this.lots.length > 1 && this.data.parkingRule) {
                const ruleId = this.data.parkingRule;
                this.changeLot(this.data.parkingLot);
                this.changeRule(ruleId);
                this.data.parkingRule = ruleId;
            }
        }
    }

    setLotAndRule() {
        this.data.parkingLot = this.lots[0].id;
        this.rules = this.lots[0].lotRule.map(rule => (rule.parkingRule));
        this.rules = this.rules.filter(rule => rule.enableStatus);
        const activeRules = this.lots[0].lotRule.filter(rule => rule.parkingRule.enableStatus);
        if(activeRules.length === 1) {
            const rule = activeRules[0].parkingRule;
            this.data.parkingRule = this.rules[0].id;
            if (rule.acceptCash)
                this.availablePaymentMethods.push({value: 'cash', displayName: 'Cash'});
            if (rule.acceptCheques)
                this.availablePaymentMethods.push({value: 'cheque', displayName: 'Cheque'});
            if (rule.acceptCreditCards)
                this.availablePaymentMethods.push({value: 'credit_card', displayName: 'Credit Card'});
            if (rule.defaultPaymentMethod)
                this.data.paymentMethod = rule.defaultPaymentMethod;
            if (rule.disclaimerStatus && (!rule.disclaimerHideFromStaffInterface || this.authService.userIsResident))
                this.disclaimerText = rule.disclaimer;
            if (rule.legalAgreementStatus && (!rule.legalAgreementHideFromStaffInterface || this.authService.userIsResident)) {
                this.termsAndConditions = rule.legalAgreement;
                this.confirmationMessage = rule.confirmationMessage;
            }
            if(rule.type == 'sliding' && rule.passTypes.length) {
                const offset = rule.passTypes[0].passTypeScheduleSliding;
                const endTime = moment(this.dateFrom).add(offset.slidingPeriodCount, offset.slidingSequenceType + 's');
                this.dateTo = endTime._d;
                this.timeTo = endTime.format('h:mm A');
                if(rule.maxPassCountPerBooking)
                    this.maxDateTo = moment(this.dateFrom).add(rule.maxPassCountPerBooking * parseInt(offset.slidingPeriodCount), offset.slidingSequenceType + 's').format();
            }
        }
    }

    getSuites(buildingId: number, suiteId?: number): void {
        if (!buildingId) return;
        this.suites = [];
        this.residents = [];
        const url = `/v1/suite/select.json?per-page=1000&order-by=suiteNumber|asc&building_id=${buildingId}`;
        this.buildingSelectIsDisabled = true;
        this.api.get('domainBD', url).subscribe(
            res => {
                const suites = JSON.parse(res._body).entities || [];
                this.suites = suites.map(suite => ({id: suite.id, name: suite.suiteNumber}));
                this.suites.push({id: 0, name: 'Other'});
                if (suiteId) this.getResidents(suiteId);
            },
            error => this.api.errorHandler(error, 'Failed get suites'),
            () => this.buildingSelectIsDisabled = false
        );
    }

    getResidents(suiteId: number): void {
        this.residents = [];
        if (!suiteId) return;
        const url = `/v1/residents/select.json?per-page=1000&suite_id=${suiteId}&expand=phones`;
        this.api.get('domainBD', url).subscribe(
            res => {
                this.fullResidentsObjectArray = [];
                if (this.data.suiteId !== 0) {
                    const residents = JSON.parse(res._body).entities;
                    this.fullResidentsObjectArray = residents;
                    this.residents = residents.map(
                        item => (new ResidentForSelect(item.id, item.fullName, [], item.email, item.isValidEmail))
                    );
                    this.residents.push(new ResidentForSelect(0, 'Other'));
                }
            },
            error => this.api.errorHandler(error, 'Failed get Residents')
        );
    }

    getBuildingNameById(id): string {
        let name = '';

        this.parkingPassService.buildings.filter(building => {
            if(building.id == id)
                name = building.name;
        });

        return name;
    }

    suiteToSearchSelect(arr: Array<any>) {
        return arr.map(suite => ({value: suite.id, optionText: suite.name}));
    }

    moveToTheNextStep(moveTo): void {
        if(moveTo != 'create-pass' && !this.checkIfAnyPassesSelected())
            toastr.warning('You must select at least one pass type to continue.');
        if(moveTo == 'create-pass') {
            this.form.submitted = false;
            this.step = moveTo;
            setTimeout(() => this.initTimePicker(), 500);
        }
        if(moveTo == 'disclaimer') {
            if(this.data.parkingLot && ((!this.authService.userIsResident && (this.data.buildingId && (this.data.suiteId || this.data.suiteNumber) &&
               (this.data.residentId || this.data.residentFullName))) || this.authService.userIsResident) && this.visitorInfoIsEmpty() &&
               this.dateFrom && this.timeFrom && this.dateTo && this.timeTo && this.checkIfAnyPassesSelected()) {
                this.step = moveTo;
                this.form.submitted = false;
            }
        }
        if(moveTo == 'terms') {
            if(this.data.parkingLot && ((!this.authService.userIsResident && (this.data.buildingId && (this.data.suiteId || this.data.suiteNumber) &&
               (this.data.residentId || this.data.residentFullName))) || this.authService.userIsResident) && this.visitorInfoIsEmpty() &&
               this.dateFrom && this.timeFrom && this.dateTo && this.timeTo && this.checkIfAnyPassesSelected()) {
                this.step = moveTo;
                this.form.submitted = false;
            }
        }
        if(moveTo == 'payment') {
            if(this.data.parkingLot && ((!this.authService.userIsResident && (this.data.buildingId && (this.data.suiteId || this.data.suiteNumber) &&
               (this.data.residentId || this.data.residentFullName))) || this.authService.userIsResident) && this.visitorInfoIsEmpty() &&
               this.dateFrom && this.timeFrom && this.dateTo && this.timeTo && this.checkIfAnyPassesSelected() &&
               (this.confirmationMessage ? this.data.acknowledgement : true)) {
                this.form.submitted = false;
                if(!this.data.payment) {
                    this.data.payment = {
                        amount: this.getTotalPaymentValue(),
                        status: false
                    };
                }
                this.step = moveTo;
            }
        }
        if(moveTo == 'summary') {
            if(this.data.parkingLot && ((!this.authService.userIsResident && (this.data.buildingId && (this.data.suiteId || this.data.suiteNumber) &&
               (this.data.residentId || this.data.residentFullName))) || this.authService.userIsResident) && this.visitorInfoIsEmpty() &&
               this.dateFrom && this.timeFrom && this.checkIfAnyPassesSelected() && this.dateTo && this.timeTo &&
               (this.confirmationMessage ? this.data.acknowledgement : true)) {
                this.step = moveTo;
                this.form.submitted = false;
            }
        }
    }

    isContinueButtonDisabled(step): boolean {
        let isDisabled = true;

        if(step == 'disclaimer') {
            isDisabled = false;
        }
        if(step == 'create-pass') {
            isDisabled = this.requiredPasses.filter(p => p.selected).length < 1;
        }
        if(step == 'terms') {
            if(!(this.confirmationMessage && !this.data.acknowledgement))
                isDisabled = false;
        }
        if(step == 'payment') {
            isDisabled = false;
        }
        if(step == 'summary') {
            isDisabled = false;
        }

        return isDisabled;
    }

    getTotalPaymentValue(): any {
        let returnValue = 0;
        this.requiredPasses.filter((pass) => {
            if(pass.selected && pass.allowOverlimitBooking && pass.fee && !pass.available)
                returnValue += parseFloat(pass.fee.replace(',', '.'));
        });
        return parseFloat(returnValue.toString()).toFixed(2);
    }

    getPaymentsFormatted(): any {
        return this.data.payment && this.data.paymentMethod ?
               {
                   status: this.data.payment.status ? 1 : 0,
                   paymentMethod: this.data.paymentMethod,
                   amount: this.data.payment.amount
               } :
               null;
    }

    calculateCurrentProgressBarLength(): string {
        const termsAndConsitionsStepExist = this.termsAndConditions || this.confirmationMessage;
        if(this.step == 'create-pass') {
            if(!this.showPaymentTab() && !termsAndConsitionsStepExist && !this.disclaimerText) return '11%';
            if( this.showPaymentTab() && !termsAndConsitionsStepExist && !this.disclaimerText) return '17%';
            if( this.showPaymentTab() &&  termsAndConsitionsStepExist && !this.disclaimerText) return '13%';
            if(!this.showPaymentTab() &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '13%';
            if( this.showPaymentTab() && !termsAndConsitionsStepExist &&  this.disclaimerText) return '13%';
            if(!this.showPaymentTab() && !termsAndConsitionsStepExist &&  this.disclaimerText) return '17%';
            if(!this.showPaymentTab() &&  termsAndConsitionsStepExist && !this.disclaimerText) return '17%';
            if( this.showPaymentTab() &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '9%';
        }
        if(this.step == 'disclaimer') {
            if(!this.showPaymentTab() &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '37%';
            if( this.showPaymentTab() && !termsAndConsitionsStepExist &&  this.disclaimerText) return '38%';
            if(!this.showPaymentTab() && !termsAndConsitionsStepExist &&  this.disclaimerText) return '50%';
            if( this.showPaymentTab() &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '30%';
        }
        if(this.step == 'terms') {
            if( this.showPaymentTab() &&  termsAndConsitionsStepExist && !this.disclaimerText) return '38%';
            if(!this.showPaymentTab() &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '62%';
            if(!this.showPaymentTab() &&  termsAndConsitionsStepExist && !this.disclaimerText) return '50%';
            if( this.showPaymentTab() &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '50%';
        }
        if(this.step == 'payment') {
            if( this.showPaymentTab() && !termsAndConsitionsStepExist && !this.disclaimerText) return '50%';
            if( this.showPaymentTab() &&  termsAndConsitionsStepExist && !this.disclaimerText) return '63%';
            if( this.showPaymentTab() && !termsAndConsitionsStepExist &&  this.disclaimerText) return '63%';
            if( this.showPaymentTab() &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '70%';
        }
        if(this.step == 'summary') {
            if(!this.showPaymentTab() && !termsAndConsitionsStepExist && !this.disclaimerText) return '89%';
            if( this.showPaymentTab() && !termsAndConsitionsStepExist && !this.disclaimerText) return '83%';
            if( this.showPaymentTab() &&  termsAndConsitionsStepExist && !this.disclaimerText) return '88%';
            if(!this.showPaymentTab() &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '88%';
            if( this.showPaymentTab() && !termsAndConsitionsStepExist &&  this.disclaimerText) return '88%';
            if(!this.showPaymentTab() && !termsAndConsitionsStepExist &&  this.disclaimerText) return '83%';
            if(!this.showPaymentTab() &&  termsAndConsitionsStepExist && !this.disclaimerText) return '83%';
            if( this.showPaymentTab() &&  termsAndConsitionsStepExist &&  this.disclaimerText) return '90%';
        }
    }

    getDateObjectInZeroTimeZone(dateString): any {
        const dateObjectInZeroTimeZone = new Date(new Date(dateString).getTime() + new Date(dateString).getTimezoneOffset() * 60000);
        return dateObjectInZeroTimeZone;
    }

    getDateTimeForSubmit(dateFromForm, timeFromForm): Date {
        const date = new Date(dateFromForm);
        const time = timeFromForm;
        const timeObj = new Date(`01/01/1970 ${time}`);
        const hours   = timeObj.getHours();
        const minutes = timeObj.getMinutes();
        date.setHours(hours);
        date.setMinutes(minutes);
        const dateConvertedToZeroTimezone = new Date(new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60000);
        return dateConvertedToZeroTimezone;
    }

    getRequiredPassTypes(): any {
        this.requiredPasses = [];
        this.passesForHint = [];
        this.limitGroupsForHint = [];
        this.data.payment = null;

        if(!this.data.parkingLot || !this.data.parkingRule || !this.data.visitorLicensePlate ||
           !this.stringWithoutSpaces(this.data.visitorLicensePlate) || !this.dateFrom ||
           !this.timeFrom || !this.dateTo || !this.timeTo) {
            this.form.submitted = true;
            this.form.controls.dateTo.touched = true;

            toastr.error('Please, fill all required information.');

            return;
        }

        const lot = 'parking_lot_id=' + this.data.parkingLot;
        const selectedBuilding = JSON.parse(localStorage.getItem('residentselectedBuilding'));
        let suite = '';
        if(selectedBuilding) {
            suite =  '&suite_id=' + selectedBuilding.suite_id;
        } else {
            suite =  '&suite_id=' + (this.data.suiteId == 0 ? this.data.buildingId + '-' + this.data.suiteNumber : this.data.suiteId);
        }
        const licensePlate = this.data.visitorLicensePlate ? ('&visitor_license_plate=' + this.data.visitorLicensePlate) : '';
        const startDate = '&start_date=' + this.getDateTimeForSubmit(this.dateFrom, this.timeFrom).toISOString();
        const endDate = '&end_date=' + this.getDateTimeForSubmit(this.dateTo, this.timeTo).toISOString();
        const onEditParameter = this.data.id ? `&booking_id=${this.data.id}` : '';
        const parkingRule = this.data.parkingRule ? `&parking_rule_id=${this.data.parkingRule}` : '';
        const url = `/v1/booking/required_pass_types.json?${lot}${suite}${licensePlate}${startDate}${endDate}${onEditParameter}${parkingRule}`;
        this.showRequiredPassTypesSpinner = true;
        this.disablePassRefresh = true;
        this.showNoPassesRequiredNotification = false;
        this.api.get('domainParkingPass', url).subscribe(
            res => {
                const body = JSON.parse(res._body) || [];
                this.limitGroupsForHint = body.limitGroups;
                body.requiredBookingPassTypes.forEach(type => {
                    const matchingPasses = this.passesForHint.filter( pass => pass.name == type.passType.name);
                    if(matchingPasses.length === 0)
                        this.passesForHint.push(type.passType);
                    this.requiredPasses.push({
                        passTypeName: type.passTypeName,
                        startTime: type.from,
                        endTime: type.to,
                        repeatable: type.passType.passTypeSchedule ? type.passType.passTypeSchedule.repeatable : false,
                        allowOverlimitBooking: type.overlimitAllowed,
                        fee: type.fee,
                        selected: type.available,
                        available: type.available,
                        passTypeId: type.passType.id
                    });
                });
                this.showRequiredPassTypesSpinner = false;
                this.disablePassRefresh = false;
                if(body.errors)
                    body.errors.filter(err => toastr.error(err.description));
                if(this.requiredPasses.length === 0)
                    this.showNoPassesRequiredNotification = true;
            },
            error => {
                this.api.errorHandler(error, JSON.parse(error._body).message);
                this.showRequiredPassTypesSpinner = false;
                this.disablePassRefresh = false;
            }
        );
    }

    onStartDateChange(form): void {
        if(new Date(this.dateFrom) > new Date(this.dateTo)) {
            this.dateTo = null;
            form.value.dateTo = null;
            this.timeTo = '';
            $('#timepickerto')[0].value = '';
        }
        this.onDateTimeChange('dateFrom');
    }

    changeAutocompleteValue(visitor) {
        this.data.visitorFullName = visitor.fullName;
        this.data.visitorVehicle = visitor.vehicle;
        this.data.visitorLicensePlate = visitor.licensePlate;
    }

    getBookingPassTypesForSending(): any {
        return this.requiredPasses.filter(pass => pass.selected).map(pass => ({
            passType: pass.passTypeId,
            dateFrom: pass.startTime,
            dateTo: pass.endTime,
            passTypeName: pass.passTypeName
        }));
    }

    checkIfAnyPassesSelected(): boolean {
        let passesSelected = false;
        if(this.requiredPasses)
            passesSelected = this.requiredPasses.filter(pass => pass.selected).length ? true : false;
        return passesSelected;
    }

    showPaymentTab(): boolean {
        const needToPayForPasses = this.requiredPasses.filter(pass => pass.selected && pass.allowOverlimitBooking && pass.fee && !pass.available);
        // return needToPayForPasses.length > 0 || this.data.payment;
        return false;
    }

    visitorInfoIsEmpty(): boolean {
        const name = this.stringWithoutSpaces(this.data.visitorFullName);
        const vehicle = this.stringWithoutSpaces(this.data.visitorVehicle);
        const licencePlate = this.stringWithoutSpaces(this.data.visitorLicensePlate);
        return name != '' && vehicle != '' && licencePlate != '';
    }

    stringWithoutSpaces(string): string {
        return typeof string == 'string' ? string.replace(/&nbsp;/g, '').replace(/\s/g, '') : '';
    }

    onDateTimeChange(value?): void {
        if(value == 'dateFrom') {
            this.dateTo = null;
            if(this.rule && this.rule.type == 'sliding') {
                const offset = this.rule.passTypes[0].passTypeScheduleSliding;
                if (this.rule.maxPassCountPerBooking)
                    this.maxDateTo = moment(this.dateFrom).add(this.rule.maxPassCountPerBooking * parseInt(offset.slidingPeriodCount), offset.slidingSequenceType + 's').format();
            }
        }
        this.requiredPasses = [];
        this.showNoPassesRequiredNotification = false;
    }

    showHint(e) {
        const $div = $(e.target).closest('.rule-details-hint-div');
        if ($div.hasClass('active'))
            $div.removeClass('active');
        else {
            $('.rule-details-hint-div').removeClass('active');
            $div.addClass('active');
        }
    }

    getNumberOfUsedPasses() {
        this.currentMonth = this.months[new Date().getMonth()];
        this.gotUsedPasses = false;
        const url = `/v1/pass_types_info.json?building_id=${this.data.buildingId}&suite_id=${this.data.suiteId}&parking_lot_id=${this.data.parkingLot}`;
        this.api.get('domainParkingPass', url).subscribe(
            res => {
                this.usedPasses = JSON.parse(res._body).filter(usedPass => usedPass.used > 0);
                this.gotUsedPasses = true;
            },
            error => this.api.errorHandler(error, 'Failed to get information about Used Passes.')
        );
    }

    getUsedPassesString() {
        return this.usedPasses.filter(pass =>
                   pass.parkingRuleId == this.data.parkingRule || this.data.parkingRule == null
               );
    }

    @HostListener('document:click', ['$event.target'])
    hideHint(targetElement: HTMLElement): void {
        if (!$(targetElement).closest('.rule-details-hint-div').length) {
            $('.rule-details-hint-div').removeClass('active');
        }
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/parking-pass/parking-pass-modal/parking-pass-modal.component.ts